var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"toast"},on:{"after-leave":_vm.onAfterLeave}},[(_vm.isShow)?_c('div',{staticClass:"toast"},[_c('div',{staticClass:"toast-content"},[_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.content))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }